<template>
    <v-container>
        <!-- Export Section -->
        <v-row>
            <v-col cols="12">
                <h3>{{$t('YouCanContinueWorking')}}</h3>
            </v-col>
            <v-col cols="12" md="6">
                <v-btn tile :loading="loadingExport" :disabled="loadingExport || !value" color="green darken-3" class="float-end white--text" @click="exportExcel">
                    <v-icon start dark size="25">
                        mdi-microsoft-excel
                    </v-icon>
                    {{ $t('EXPORT') }}
                </v-btn>
               
            </v-col>
        </v-row>

        <!-- Import Section -->
        <v-row class="mt-4">
            <v-col cols="12" md="6">
                <v-file-input label="Import Excel File"
                              accept=".xlsx, .xls"
                              v-model="file"
                              outlined
                              dense></v-file-input>
            </v-col>
            <v-col cols="12" md="6">
                <v-btn color="secondary" :loading="loadingExport"
                       :disabled="!file || !value"
                       @click="importExcel">
                    Import Excel
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import SurveyService from '@/services/SurveyService'
    import { downloadFile } from '@/helpers/downloader.js'
    export default {
        data() {
            return {
                file: null, // File selected for import
                loadingExport:false
            }
        },
        props:{
            value: {
            type: Number,
            default: 0
        },

        },
        methods: {
            // Export Excel
            async exportExcel() {
                this.loadingExport = true
                    SurveyService.exportToExcelForEdit(this.value).then(res => {
                    downloadFile(res)
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loadingExport = false
                })
                    
                
            },

            // Import Excel
            async importExcel() {
                try{
                    this.loadingExport = true
                    const formData = new FormData()
                    formData.append('file', this.file)
                    var data = await SurveyService.importExcelForEdit(this.value, formData)
                    if(data.success)
                        this.$root.$notification(this.$t('UpdateSuccess'), 'success')
                    else
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }
                catch (ex) {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }
                this.loadingExport = false
                
            },
        },
    }
</script>
